






































































import moment from 'moment';
import {
  Vue, Prop, Component, Emit,
} from 'vue-property-decorator';
import CardBasic from '@/shared/card/card-basic.component.vue';
import DateFormat from '@/shared/utils/date-format'
import InstanceSummary from '@/domain/contract/entity/instances-summary.entity';
import OverviewMainCardTable from './overview-main-card-table.component.vue';
import ContractSummary from '../../domain/contract/entity/contract-summary.entity';
import OverviewMainCardCompetenceSelect from './overview-main-card-competence-select.component.vue';
import OverviewMainCardExpandable from './overview-main-card-expandable.component.vue';
import Summary from '../../domain/billing/entity/summary.entity';
import OverviewInstancesComponent from './instances/overview-instances.component.vue';

const INACTIVES_WITH_CONSUMPTION: string[] = [
  'INACTIVE_WITH_INACTIVE_INSTANCES_AND_CONSUMPTION',
  'CANCELED_WITH_INACTIVE_INSTANCES_AND_CONSUMPTION',
];

@Component({
  components: {
    CardBasic,
    OverviewMainCardTable,
    OverviewMainCardCompetenceSelect,
    OverviewMainCardExpandable,
    OverviewInstancesComponent,
  },
})
export default class OverviewMainCard extends Vue {
  @Prop({
    required: true,
  })
  private contractSummary!: ContractSummary;

  @Prop({
    required: true,
  })
  private summary!: Summary;

  @Prop({
    required: false,
    default: new Date().toISOString().substring(0, 7),
  })
  private competenceMonth!: string;

  @Prop({
    required: false,
    default: undefined,
  })
  private fetchedAt!: string;

  @Prop({
    type: InstanceSummary,
  }) private instanceSummary!: InstanceSummary;

  @Emit('updateCompetenceMonth')
  private updateCompetenceMonth(value: string): string {
    return value;
  }

  private goToContractsView(status: string): void {
    const newStatus: string = status === 'INCONSISTENT_ITEMS' ? 'INCONSISTENT' : status;
    if (INACTIVES_WITH_CONSUMPTION.includes(status)) {
      window.open(`/contracts?status=${newStatus}&competenceFilter=${this.competenceMonth}`, '_blank');
      return;
    }
    if (status === 'INACTIVE_ON_COMPETENCE') {
      const [firstDayOfMonth, lastDayOfMonth] = DateFormat
        .getFirstAndLastDayOfMonthByCompetence(this.competenceMonth)
      window.open(`/contracts?status=INACTIVE&periodStart=${firstDayOfMonth}&periodEnd=${lastDayOfMonth}`, '_blank');
      return;
    }
    if (status === 'CANCELED_ON_COMPETENCE') {
      const [firstDayOfMonth, lastDayOfMonth] = DateFormat
        .getFirstAndLastDayOfMonthByCompetence(this.competenceMonth)
      window.open(`/contracts?status=CANCELED&periodStart=${firstDayOfMonth}&periodEnd=${lastDayOfMonth}`, '_blank');
      return;
    }
    if ((status === 'ACTIVE_WITH_EXPIRE_IN') || (status === 'INACTIVE_WITH_EXPIRE_IN')) {
      window.open(`/contracts?status=${status}&competenceFilter=${this.competenceMonth}`, '_blank');
      return;
    }
    window.open(`/contracts?status=${newStatus}`, '_blank');
  }

  private goToBillingsView(status: string, competence: string): void {
    const path: string = competence === '' ? `/billing/${status}` : `/billing/${status}/${competence}`;
    window.open(path, '_blank');
  }

  private get pastMonth(): string {
    const date: Date = new Date();
    date.setDate(1);
    date.setMonth(date.getMonth() - 1);
    return new Date(date).toISOString().substring(0, 7);
  }

  private formatHour(fetchedAt: string): string {
    if (!fetchedAt) return '';
    return moment(fetchedAt).format('HH:mm');
  }

  private formateDateHour(fetchedAt: string): string {
    return moment(fetchedAt).format('DD/MM/YYYY HH:mm:ss');
  }

  private forceSummaryUpdate(): void {
    this.$emit('forceSummaryUpdate');
  }

  private goToInstanceView(status: string, withConsumption: string) {
    const instanceUrl = this.$router.resolve({
      name: 'InstanceDataTable',
      query: {
        status,
        withConsumption,
        competence: this.competenceMonth,
      },
    });
    window.open(instanceUrl.href, '_blank');
  }
}
